import type { PipeTransform } from '@angular/core';

import { Pipe } from '@angular/core';
import { AcceptEnum } from '@commons/bo-ui/form/file-picker/models/accept.enum';

@Pipe({ name: 'fileType' })
export class FileTypePipe implements PipeTransform {
  transform(types: AcceptEnum[] | string[], separator = ', '): any {
    const result: string[] = [];
    types = Array.isArray(types) ? types : [types];

    for (const type of types) {
      switch (type as AcceptEnum) {
        case AcceptEnum.JPG:
          result.push('JPEG');
          break;

        case AcceptEnum.PNG:
          result.push('PNG');
          break;

        case AcceptEnum.SVG:
          result.push('SVG');
          break;

        case AcceptEnum.PDF:
          result.push('PDF');
          break;

        default:
          break;
      }
    }

    return result.join(separator);
  }
}
